import { call, select } from 'redux-saga/effects';
import productUtils from '../../../product/js/utils/utils';
import { getFlatNavigationSaga } from '@core/js/utils/navigationUtils';

/**
 * Add some goodies to the recommendations products for tracking and what not
 * @param  {object} rawProducts  raw products response
 * @param  {array} products  list of products from catalog
 * @return {array}            list of orchestrated recommended products
 */
export function orchestrateRecommendations(rawProducts, products) {
    // Add Click Tracking URL to each product
    const recommendedProducts = _.get(rawProducts, 'recommendedProducts', []);

    for (let i = 0; i < recommendedProducts.length; i++) {
        const rawProduct = recommendedProducts[i];

        const pIndex = _.findIndex(products, (o) => o.product.productId === rawProduct.id);

        if (pIndex !== -1) {
            const product = products[pIndex];

            // Rich Relevance uses clickTrackingURL, Groundhog uses clickURL
            product.clickTrackingURL = rawProduct.clickURL || rawProduct.clickTrackingURL;
        }
    }

    return getRecommendedStrategyId(rawProducts, products);
}

/**
 * Adds the strategy Id (strId) to all products
 * @param  {object} rawProducts  raw products response
 * @param  {array}  products     list of products from catalog
 * @return {array}               list of orchestrated recommended products
 */
export function getRecommendedStrategyId(rawProducts, products) {
    const items = rawProducts.items;
    for (const product of products) {
        const productId = _.get(product, 'product.productId');
        const productIndex = _.findIndex(items, { item: { sku: productId } });

        if (productIndex !== -1) {
            product.product.strId = _.get(rawProducts, `items[${productIndex}].strId`);
        }
    }

    return products;
}

/**
 * Get RR Product Recommendations source details
 * @return {object}     recommendations source details
 */
export function* getRecommendationsSource() {
    // ensure flat nav is in the redux store
    yield call(getFlatNavigationSaga);

    const state = yield select();
    const product = productUtils.getTargetedProduct(state);

    let styleNumber;
    let categoryId;

    if (typeof product !== 'undefined' && typeof product.styleNumber !== 'undefined') {
        styleNumber = product.styleNumber;
    }

    if (typeof product !== 'undefined' &&
        typeof product.browseCategory !== 'undefined' &&
        typeof state.core.flatNavigation[product.browseCategory] !== 'undefined') {
        categoryId = state.core.flatNavigation[product.browseCategory].categoryId;
    }

    return {
        styleNumber: styleNumber,
        categoryId: categoryId
    };
}

/**
 * Get products from recommendations that are in stock
 * @param  {array} products  list of recommended products
 * @return {array}            list of recommended products that are in stock
 */
export function filterOutSoldOutProducts(products) {
    return _.filter(products, (o) => !(o.product && o.product.isSoldOut));
}

/**
 * Replace periods (.) from Rich Relevance placements with double underscores (__)
 * This makes it easier to use the placements as properties to a JS object
 * @param  {String} placementId a RR placement
 * @return {String} sanitized RR placement, if possible
 */
export function sanitizePlacementId(placementId) {
    if (_.isString(placementId)) {
        return placementId.replace(/\./g, '__');
    }

    return placementId;
}
